import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useHistory } from 'react-router-dom';
import { connect } from "react-redux";
import FormField from '../../dynamicFormBuilder/FormField'
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import { PrimaryLayout, CodesLayout, RefrencesLayout, AddressLayout,AdditionalFormLayout, FMDefaultsLayout, HistoryLayout,OMDefaultsLayout,SummaryLayout 
    ,ConsigneeCodesLayout,ConsigneeCRefrencesLayout,EdiDefaultLayout,ConsigneeWMDefaultLayout
} from './Layouts';
import { AdditionalLayout as CarrierAdditionalLayout, CodesLayout as CarrierCodesLayout, ReferencesLayout as CarrierReferencesLayout, WMDefaultsLayout as CarrierWMDefaultsLayout, OMDefaultsLayout as CarrierOMDefautlsLayout} from './../codes/carrierDataEntry/Layouts';


function HeaderFrom(props) {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    let combinedLayouts ;
    let layoutId;
    if(props.IdType ==="02")
    {
        layoutId ='CF129C78-620E-4921-8F7F-87C99E2E821C';
        combinedLayouts = [
            { name: 'PrimaryLayout', layout: PrimaryLayout },
            { name: 'ConsigneeCodesLayout', layout: ConsigneeCodesLayout },
            { name: 'ConsigneeCRefrencesLayout', layout: ConsigneeCRefrencesLayout },
            { name: 'EdiDefaultLayout', layout: EdiDefaultLayout },
            { name: 'ConsigneeWMDefaultLayout', layout: ConsigneeWMDefaultLayout },
        ];
    }
    else if(props.IdType ==="01")
    {
        layoutId ='5BF440AF-D54F-4C21-B49F-39A22D96E99B';
        combinedLayouts = [
            { name: 'PrimaryLayout', layout: PrimaryLayout },
            { name: 'CodesLayout', layout: CodesLayout },
            { name: 'RefrencesLayout', layout: RefrencesLayout },
            { name: 'AddressLayout', layout: AddressLayout },
            { name: 'AdditionalFormLayout', layout: AdditionalFormLayout },
            { name: 'FMDefaultsLayout', layout: FMDefaultsLayout },
            { name: 'HistoryLayout', layout: HistoryLayout },
            { name: 'FMDefaultsLayout', layout: FMDefaultsLayout },
            { name: 'OMDefaultsLayout', layout: OMDefaultsLayout },
            { name: 'SummaryLayout', layout: SummaryLayout },
        ];  
    }
    else if(props.IdType ==="05")
    {
        layoutId ='BE754E22-A773-40BB-8149-A2940DD68408';
        combinedLayouts = [
            { name: 'PrimaryLayout', layout: PrimaryLayout },
            { name: 'AdditionalFormLayout', layout: CarrierAdditionalLayout },
            { name: 'CodesLayout', layout: CarrierCodesLayout },
            { name: 'RefrencesLayout', layout: CarrierReferencesLayout },
            { name: 'OMDefaultsLayout', layout: CarrierOMDefautlsLayout },
            { name: 'WMDefaultsLayout', layout: CarrierWMDefaultsLayout },
        ];  
    } 
    else if(props.IdType ==="06")
    {
        layoutId ='E24E4E00-24EA-4A71-BF9D-89DD399A8356';
        combinedLayouts = [
            { name: 'PrimaryLayout', layout: PrimaryLayout },
            { name: 'AddressLayout', layout: AddressLayout },
        ];  
    }
    const updatedLayouts = combinedLayouts.map(({ name, layout }) => {
        if (name !== 'PrimaryLayout') {
            return layout.map(group => ({
                ...group,
                label: "", 
                fields: group.fields.map(field => ({
                    ...field,
                    visible: false
                }))
            }));
        }
        return layout;
    });
    
    const finalLayout = updatedLayouts.flat();

    const handlePrimaryFormLoad = useCallback(() => {
        props.primaryFormLookupsLoad(formRefs);

    }, []);
        useEffect(() => {
            if(formRefs.current['R_PROFILE']){
                if(props.formFields.ROWID!=="00000000-0000-0000-0000-000000000000")
                    {formRefs.current['R_PROFILE'].instance().option('disabled', true);}
                else 
                 {formRefs.current['R_PROFILE'].instance().option('disabled', false);}
            }
        }, [props.formFields]);

    const handleSelectionChange = useCallback((name, e) => {
    }, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId={layoutId}
                layoutName='IDDataEntryPrimayForm'
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={props.handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handlePrimaryFormLoad}
                handleSelectedItemChange={handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(HeaderFrom);
